<template lang="pug">
.gamepix-page
  .gamepix-page__header
    InlineSvg.gamepix-page__header-back(:src="require('~/assets/img/icons/angle-left.svg')" @click="goBack")
    .gamepix-page__header-icon
      InlineSvg.gamepix-page__header-icon-image(:src="require('~/assets/img/icons/tetris.svg')")
    .gamepix-page__h1(v-t="'gamepixH1'")

  //.gamepix-page__cards-container
  //  .gamepix-page__cards
  //    .gamepix-page__card(v-for="(card, index) in cards" :key="card.title")
  //      .gamepix-page__point-container
  //        .gamepix-page__point-number 0{{index + 1}}
  //      .gamepix-page__point-block
  //        img.gamepix-page__point-icon(src="https://cdn.gaming-goods.com/images/other/info/blue-point.png")
  //        img.gamepix-page__line(src="https://cdn.gaming-goods.com/images/other/info/gradient-line-1.png")
  //      .gamepix-page__card-title(v-t="card.title")
  //      .gamepix-page__card-text(v-t="card.text")

  .gamepix-page__games
    .gamepix-page__game(v-for="game in list" :key="game.name")
      .gamepix-page__game-top
        img.gamepix-page__game-icon(:src="game.icon" alt="icon")
        .gamepix-page__game-title {{ game.title }}
      NuxtLink(:to="localeLocation(`/game-pix/tournaments?subgame=${game.name}`)")
        button.gamepix-page__game-button
          | {{ $t('play') }}
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      cards: [
        {
          title: 'gamepixPoint1Title',
          text: 'gamepixPoint1Text'
        },
        {
          title: 'gamepixPoint2Title',
          text: 'gamepixPoint2Text'
        },
        {
          title: 'gamepixPoint3Title',
          text: 'gamepixPoint3Text'
        }
      ]
    }
  },

  computed: {
    ...mapState('games', ['games']),

    list () {
      return this.games.find(game => game.name === 'game-pix')?.extra_data?.sub_games
    }
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.gamepix-page__header-back {
  path {
    fill: $white;
  }
}
</style>

<style lang="scss" scoped>
.gamepix-page {
  width: 100%;

  &__header {
    width: 100%;
    min-height: 200px;
    padding: 16px;
    background: url('https://cdn.gaming-goods.com/images/gamepix/gpheader-mobile.webp');

    @media (min-width: $breakpointTablet) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      padding: 20px 24px;
    }

    @media (min-width: $breakpointDesktop) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-start;
      height: 331px;
      padding: 20px 106px;
    }

    &-back {
      padding-left: 8px;
      width: 32px;

      @media (min-width: $breakpointTablet) {
        display: none;
      }
    }

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      margin-top: 29px;
      margin-bottom: 4px;
      background: $blue-grey70;
      border-radius: 24px;
      border: 2px solid #aaa;
      border-bottom: none;
      border-top: none;

      @media (min-width: $breakpointTablet) {
        width: 66px;
        height: 66px;
        border-radius: 33px;
        margin-bottom: 20px;
      }

      @media (min-width: $breakpointDesktop) {
        margin-bottom: 0;
        margin-right: 32px;
        border-radius: 60px;
        width: 120px;
        height: 120px;
      }

      &-image {
        width: 16px;
        height: 16px;

        @media (min-width: $breakpointTablet) {
          width: 24px;
          height: 24px;
        }

        @media (min-width: $breakpointDesktop) {
          width: 45px;
          height: 45px;
        }
      }
    }
  }

  &__h1 {
    max-width: 272px;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: $white;

    @media (min-width: $breakpointTablet) {
      max-width: 100%;
    }

    @media (min-width: $breakpointDesktop) {
      font-size: 40px;
      line-height: 48px;
      max-width: 420px;
      margin-bottom: 38px;
    }
  }

  &__cards {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-gap: 32px;
    overflow-x: auto;
    padding-bottom: 20px;

    @media (min-width: $breakpointTablet) {
      grid-gap: 48px;
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: repeat(3, 1fr);
      width: calc(100% - 106px);
    }

    &-container {
      margin-top: 48px;
      margin-left: 16px;
      width: 100%;
      overflow: hidden;

      @media (min-width: $breakpointTablet) {
        margin-left: 24px;
      }

      @media (min-width: $breakpointDesktop) {
        margin-left: 106px;
        margin-right: 106px;
      }
    }
  }

  &__card {
    width: 168px;

    @media (min-width: $breakpointTablet) {
      width: 220px;
    }

    @media (min-width: $breakpointDesktop) {
      width: 240px;
    }

    &-title {
      margin-bottom: 8px;
      color: #cfd8dc;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
    }

    &-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: $blue-grey05;
    }

    &-more-info {
      margin-top: 8px;
      margin-left: 16px;
      color: $primary60;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__point {
    &-container {
      display: grid;
      grid-gap: 24px;
      grid-template-columns: 1fr 40px 136px;
      align-items: center;

      @media (min-width: $breakpointDesktop) {
        grid-template-columns: 1fr 40px 261px;
      }
    }

    &-block {
      display: flex;
      align-items: center;
    }

    &-number {
      font-style: normal;
      font-weight: 500;
      font-size: 64px;
      line-height: 90px;
      color: $primary60;

      &--muted {
        color: $blue-grey30;
      }
    }
  }

  &__games {
    display: grid;
    padding: 16px;
    grid-gap: 16px;

    @media (min-width: $breakpointTablet) {
      padding: 24px;
      margin-top: 30px;
    }

    @media (min-width: $breakpointDesktop) {
      padding: 24px 106px;
      margin-top: 60px;
    }

    @media (min-width: $breakpointTablet) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__game {
    background-color: $blue-grey70;
    border-radius: 16px;
    padding: 20px;

    &-top {
      display: grid;
      grid-template-columns: max-content 1fr;
      grid-gap: 16px;
      align-items: center;
    }

    &-icon {
      width: 56px;
      height: 56px;
    }

    &-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      color: $white;
    }

    &-button {
      height: 48px;
      width: 100%;
      margin-top: 16px;
      background-color: $blue-grey50;
      color: $white;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      border-radius: 8px;
      cursor: pointer;
    }
  }
}
</style>
